import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
// import { deleteAndRestoreProduct } from "../reduxSaga/actions";
import { Alert, Snackbar } from "@mui/material";
import RestoreFromTrashRoundedIcon from "@material-ui/icons/RestoreFromTrashRounded";
import SocieteAndUserService from "../../../services/societeAndUser";
import UtilsUrl from "../../../utils/UtilsUrl";
import SocieteService from "../../../services/SocieteService";

const ContactTable = ({ listClients }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [clients, setClients] = useState(listClients);
  // const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);

  const { SearchBar } = Search;
  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };

  //   function tvaFormatter(cell, row) {
  //     console.log("row", row);
  //     if (row.typeTva === "Normale") {
  //       return <span>{row.tva}</span>;
  //     } else {
  //       return (
  //         <span>
  //           <span class="badge badge-warning" style={{ color: "white" }}>
  //             {row.typeTva}
  //           </span>
  //         </span>
  //       );
  //     }
  //   }
  const onDeleteOrRestaureSociete = (
    isDeleted,
    idUserToDelete,
   
  ) => {
    SocieteService.deleteAndRestoreContact(
      idUserToDelete,
      isDeleted
    )
      .then((response) => {
        if (Object.keys(response.data)[0] === "success") {
          window.location.href = "/tiers";
        } else if (Object.keys(response.data)[0] === "error") {
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connexion");
      });

  };
  function buttonDeleteFormatter(cell, row) {
    if (row.isDeleted === 0) {
      return (
        <span>
          <button
            className="btn btn-danger"
            onClick={(e) => {
              onDeleteOrRestaureSociete(1, row.id);
              setOpenInfoAlert(true);
              setInfoAlertText("Element supprimé avec succée ");
              setClients(clients.filter((dept) => dept.id !== cell));
            }}
          >
            <h6>
              <small>
                <i class="fas fa-trash"></i>
              </small>
            </h6>
          </button>
        </span>
      );
    } else if (row.isDeleted === 1) {
      return (
        <span>
          <button
            className="btn btn-info"
            onClick={(e) => {
            
              onDeleteOrRestaureSociete(0, row.id);

              setInfoAlertText("Element restauré avec succée ");
              setOpenInfoAlert(true);
              setClients(clients.filter((dept) => dept.id !== cell));
            }}
          >
            <h6>
              <small>
                <RestoreFromTrashRoundedIcon />
              </small>
            </h6>
          </button>
        </span>
      );
    }
  }
  function voirPlusButtonFormatter(cell, row) {
    return (
      <span>
        <button
          className="btn btn-dark"
          onClick={(e) => {
            sessionStorage.setItem("idPersonnel", cell);
            navigate(`/updatePersonnel`);
          }}
        >
          <i class="fas fa-solid fa-user-check"></i>
        </button>
      </span>
    );
  }
  function logoFormatter(cell, row) {
    return (
      <span>
        <img
          alt=""
          src={UtilsUrl.fileRetailURL() + row.fileUrl}
          class="rounded-circle"
          style={{ width: "50px", height: "50px" }}
        ></img>
      </span>
    );
  }
  function nameFormatter(cell, row) {
    return (
      <span>
        {row.firstName} {row.lastName}
      </span>
    );
  }
 

  const columns = [
    {
      dataField: "id",
      text: "Image",
      formatter: logoFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "name",
      text: "Nom & Prénom",
      align: "center",
      formatter: nameFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "email",
      text: "Email",
      //   align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },

    {
      dataField: "phoneNumber",
      text: "Numéro ",
      //   align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "cin",
      text: "CIN",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "13%" };
      },
    },
    {
        dataField: "fonctionContact",
        text: "Fonction",
        align: "center",
        headerAlign: "center",
        headerStyle: () => {
          return { width: "13%" };
        },
      },
   
    // {
    //   dataField: "id",
    //   text: "Plus d'info",
    //   formatter: voirPlusButtonFormatter,
    //   align: "center",
    //   headerAlign: "center",
    //   headerStyle: () => {
    //     return { width: "10%" };
    //   },
    // },
    {
      dataField: "id",
      text: "Actions",
      formatter: buttonDeleteFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
  ];

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  function handleTableChange({ products }) {
    return products;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  return (
    <div className="card card-dark">
    <div className="card-header">
      <h5 className="card-title"> Les contacts</h5>
    </div>

    <div class="card-body">
        <ToolkitProvider
          keyField="id"
          data={listClients}
          columns={columns}
          onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                <div className="ml-auto mr-0">
                  <MyExportCSV {...props.csvProps}></MyExportCSV>
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                  //   expandRow={expandRow}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
    </div>
  );
};
export default ContactTable;
